import React, { Suspense } from 'react';
import Loader from '../../../../components/commons/helpers/loader/loader.component';

function NewJobAlertLandingPage({ page: { MainContent, breadCrumbList } }) {
  const HeroComponent = React.lazy(() =>
    import('./new-job-alert-hero-component')
  );
  const ContentComponent = React.lazy(() =>
    import('./new-job-alert-content-component')
  );

  return (
    <div className="alert-container">
      <Suspense fallback={<Loader />}>
        <HeroComponent
          MainContent={MainContent}
          breadCrumbList={breadCrumbList}
        />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <ContentComponent MainContent={MainContent} />
      </Suspense>
    </div>
  );
}

export default NewJobAlertLandingPage;
